import { render, staticRenderFns } from "./WallpapersForm.vue?vue&type=template&id=8ae4b3fc&scoped=true&"
import script from "./WallpapersForm.vue?vue&type=script&lang=js&"
export * from "./WallpapersForm.vue?vue&type=script&lang=js&"
import style0 from "./WallpapersForm.vue?vue&type=style&index=0&id=8ae4b3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae4b3fc",
  null
  
)

export default component.exports